import { ShipmentState } from "./ShipmentState.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";
import { t } from "@lingui/core/macro";

import {ID, ListRequest} from "../../../types/global.d";
import {OrderBy} from "../../../types/global.d";

export type HistoryType = 'Shipment' | 'Log' | 'Cordwood';

export interface MergedHistory {
    id: ID;
    historyType: HistoryType;
    entityId: ID;
    key?: string;
    action: string;
    contextHistory?: string;
    updatedAt: Date;
    scopeGroupId: ID;
    siteId?: string;
    cuttingId?: ID;
    storageId?: ID;
    volume?: number;
    state?: ShipmentState;
    length?: number;
    diameter?: number;
    measurementType?: CordwoodMeasurementType;
    linked?: boolean;
    commited: boolean;
    shipmentId?: ID;
    buyerId?: ID;
    reportKey?: string;
    shipmentType?: string;
}

export interface PresentationMergedHistoryRequest {
    list: ListRequest;
    historyTypes?: HistoryType[];
    action?: string;
    actionOr?: boolean;
    updatedAtFrom?: Date;
    updatedAtTo?: Date;
    cuttingId?: ID;
    storageId?: ID;
    orderBys?: OrderBy[];
    caseSensitive?: boolean;
}

export function toStringHistoryType(value?: HistoryType): string | undefined {
    switch (value) {
        case 'Shipment':
            return t`Shipment`;
        case 'Log':
            return t`Log`;
        case 'Cordwood':
            return t`Cordwood`;
        default:
            return undefined;
    }
}

export function toStringAction(value?: string): string {
    switch (value) {
        case 'create':
            return t`Created`;
        case 'update':
            return t`Updated`;
        case 'delete':
            return t`Deleted`;
        case 'shipment/cancel':
            return t`Cancelled from Shipment`;
        default:
            return value || '';
    }
}